export default __webpack_public_path__ + "static/media/blueberriesTtsIt_It60.eb2d527a.mp3";